import { render, staticRenderFns } from "./WelcomeCurtain.vue?vue&type=template&id=7e810a09&"
import script from "./WelcomeCurtain.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCurtain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports